import { render, staticRenderFns } from "./ManualPositions.vue?vue&type=template&id=6201d032&scoped=true"
import script from "./ManualPositions.vue?vue&type=script&lang=js"
export * from "./ManualPositions.vue?vue&type=script&lang=js"
import style0 from "./ManualPositions.vue?vue&type=style&index=0&id=6201d032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201d032",
  null
  
)

export default component.exports